"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocalStorageAcceptedCookies_1 = require("./AcceptedCookiesStrategy/Strategies/LocalStorageAcceptedCookies");
var CookiesClient_1 = require("./CookiesClient");
var CookiesConsent_1 = require("./CookiesConsent");
var BrowserCookies_1 = require("./cookieStrategy/Strategies/BrowserCookies");
function createBrowserServices(_a) {
    var cookie_domain = _a.cookie_domain, show_policy_cookies = _a.show_policy_cookies, internal_api_url = _a.internal_api_url, version_files_js = _a.version_files_js, Texts = _a.Texts, StatsData = _a.StatsData, search = _a.search;
    var cookieStrategy = new BrowserCookies_1.default(cookie_domain);
    var acceptedCookiesStrategy = new LocalStorageAcceptedCookies_1.default(internal_api_url, version_files_js, cookieStrategy);
    var $Cookies = new CookiesClient_1.default(cookieStrategy, acceptedCookiesStrategy, show_policy_cookies);
    var $CookiesConsent = new CookiesConsent_1.default({
        $Cookies: cookieStrategy,
        $AcceptedCookies: acceptedCookiesStrategy,
        INTERNAL_API_URL: internal_api_url,
        VERSION_FILES_JS: version_files_js,
        Texts: Texts,
        StatsData: StatsData,
        Search: search,
    });
    return [$Cookies, $CookiesConsent];
}
exports.default = createBrowserServices;
//# sourceMappingURL=createBrowserServices.js.map